var React = require('react');

function ShareEmailInline (props) {
    return React.createElement("path",props);
}

ShareEmailInline.defaultProps = {"transform":"translate(0,2)","d":"M12,11.13a1.16,1.16,0,0,1-.71-.27L0,2.19v13.5a2.25,2.25,0,0,0,2.3,2.12H21.7A2.25,2.25,0,0,0,24,15.69V2.19L12.71,10.86a1.15,1.15,0,0,1-.71.24Zm0-2.5L1.3.37a2.46,2.46,0,0,1,1-.21H21.7a2.46,2.46,0,0,1,1,.21Z"};

module.exports = ShareEmailInline;

ShareEmailInline.default = ShareEmailInline;
